import type { setupWizardMessagesDe } from "./messages.setup.de";

/** English texts of the setup assistant (F-72); spread into the English dictionary. */
export const setupWizardMessagesEn: Readonly<Record<keyof typeof setupWizardMessagesDe, string>> = {
  "setupWizard.steps": "Setup steps",
  "setupWizard.progressLabel": "Setup progress",
  "setupWizard.progressValue": "{done} of {total} steps done",
  "setupWizard.start": "Start the setup",
  "setupWizard.continueWith": "Continue with “{step}”",
  "setupWizard.allDone": "All steps are done. You can still open and change every step.",
  "setupWizard.freeOrder":
    "The order is a suggestion. You can open any step at any time and continue later.",
  "setupWizard.state.done": "Done",
  "setupWizard.state.started": "Started",
  "setupWizard.state.open": "Open",
  "setupWizard.state.unreported": "No state",
  "setupWizard.allCountedDone":
    "All steps with a state are done. You can still open and change every step.",
  "setupWizard.unreportedHint":
    "There is no information yet for steps with “No state”. They do not count towards the progress; you can still open and edit them.",
  "setupWizard.unreportedStep":
    "There is no information yet for this step. It does not count towards the progress; you can still edit it.",
  "setupWizard.position": "Step {number} of {total}",
  "setupWizard.items": "State of this step",
  "setupWizard.navigation": "Move between the steps",
  "setupWizard.back": "Back",
  "setupWizard.backNamed": "Back to “{step}”",
  "setupWizard.next": "Continue",
  "setupWizard.nextNamed": "Continue to “{step}”",
  "setupWizard.overview": "To the overview",
  "setupWizard.later": "Do later",
  "setupWizard.laterNamed": "Do later: “{step}”",
  "setupWizard.laterAnnounced": "“{step}” stays open. You find the step in the setup overview.",
  "setupWizard.step.establishment.title": "Establishment and special rules",
  "setupWizard.step.establishment.summary":
    "Check the federal state, industries and Sunday exemption of each establishment and whether special rules apply to your business.",
  "setupWizard.step.work-time-models.title": "Work time models",
  "setupWizard.step.work-time-models.summary":
    "Create models from templates and check target hours and working days in the administration.",
  "setupWizard.step.information.title": "Works council and information",
  "setupWizard.step.information.summary":
    "Involve the works council, if there is one, and inform the employees about the processing of their data. Confirm both here.",
  "setupWizard.step.employees.title": "Employees",
  "setupWizard.step.employees.summary":
    "Add the employees from a CSV file or one by one. The step is done once there are employees besides you.",
  "setupWizard.step.leave.title": "Leave rules and leave balances",
  "setupWizard.step.leave.summary":
    "Set the leave rules under “Tenant”; without them there are no leave accounts. Take over remaining leave from the previous system here.",
  "setupWizard.step.invitations.title": "Invitations and first clock event",
  "setupWizard.step.invitations.summary":
    "Send the invitations; the employees then set their password and can clock in. The step is done with the first clock event.",
};
